import { render, staticRenderFns } from "./EngagementTaskChat.vue?vue&type=template&id=b0da8228&"
import script from "./EngagementTaskChat.vue?vue&type=script&lang=js&"
export * from "./EngagementTaskChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports